__turbopack_context__.v({
  "CatelogCategorySection": "CatelogCategory-module___8jfoq__CatelogCategorySection",
  "bookCardContainer": "CatelogCategory-module___8jfoq__bookCardContainer",
  "topPaddingCookie": "CatelogCategory-module___8jfoq__topPaddingCookie",
  "topPaddingNoCookie": "CatelogCategory-module___8jfoq__topPaddingNoCookie",
});
